import { render, staticRenderFns } from "./BaseDetail.vue?vue&type=template&id=7fb72f4a&scoped=true&"
import script from "./BaseDetail.vue?vue&type=script&lang=js&"
export * from "./BaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./BaseDetail.vue?vue&type=style&index=0&id=7fb72f4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb72f4a",
  null
  
)

export default component.exports